import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import React from 'react';
import { TnButton } from '../TnButton';
import { Step } from './StepperHeader';

export interface SecondaryConfirmDetails {
  shouldEnableSecondaryConfirmButton: boolean;
  secondardyConfirmTitle: string;
  handleSecondaryConfirmPressed: () => void;
}

export interface StepWithConfirmButtonFooterDetails {
  handleStepChange: (currentStep: number) => void;
  currentStep: number;
  steps: Step[];
  secondaryConfirmDetails?: SecondaryConfirmDetails;
}

interface StepWithConfirmButtonFooterProps extends StepWithConfirmButtonFooterDetails {
  isLoading: boolean;
  shouldEnableConfirmButton: boolean;
  confirmButtonTitle: string;
  handleConfirmPressed: () => void;
}

const StepWithConfirmButtonFooter = ({
  isLoading,
  handleStepChange,
  currentStep,
  steps,
  shouldEnableConfirmButton,
  confirmButtonTitle,
  handleConfirmPressed,
  secondaryConfirmDetails,
}: StepWithConfirmButtonFooterProps) => {
  const classes = useStyles();

  const renderSecondaryDetails = () => {
    if (secondaryConfirmDetails) {
      return (
        <TnButton
          title={secondaryConfirmDetails.secondardyConfirmTitle}
          variant="outlined"
          color="primary"
          disabled={!secondaryConfirmDetails.shouldEnableSecondaryConfirmButton || isLoading}
          onClick={secondaryConfirmDetails.handleSecondaryConfirmPressed}
          value={secondaryConfirmDetails.secondardyConfirmTitle}
        />
      );
    }
  };

  return (
    <Grid container alignItems="center" justify="space-between" className={classes.footerContainer}>
      <Grid item>
        {currentStep > 0 && (
          <TnButton
            title={steps[currentStep - 1].title}
            variant="outlined"
            color="secondary"
            onClick={() => handleStepChange(currentStep - 1)}
            disabled={isLoading}
            value={steps[currentStep - 1].title}
            icon={{ icon: <ArrowBackIos style={{ height: 12 }} />, position: 'start' }}
            style={{ marginRight: '8px' }}
          />
        )}
      </Grid>
      <Grid item className={classes.buttonGroup}>
        {currentStep < steps.length - 1 ? (
          <>
            {renderSecondaryDetails()}
            <TnButton
              title={steps[currentStep + 1].title}
              variant="contained"
              color="primary"
              disabled={!shouldEnableConfirmButton || isLoading}
              onClick={() => handleStepChange(currentStep + 1)}
              value={steps[currentStep + 1].title}
              icon={{ icon: <ArrowForwardIos style={{ height: 12 }} />, position: 'end' }}
            />
          </>
        ) : (
          <TnButton
            title={confirmButtonTitle}
            variant="contained"
            color="primary"
            disabled={!shouldEnableConfirmButton || isLoading}
            onClick={() => handleConfirmPressed()}
            value={confirmButtonTitle}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default StepWithConfirmButtonFooter;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footerContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      paddingLeft: 32,
      paddingRight: 32,
      paddingTop: 24,
      paddingBottom: 24,
    },
    buttonGroup: {
      display: 'flex',
      flexDirection: 'row',
      gap: 16,
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
  }),
);
